// app/javascript/controllers/locale_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  change(event) {
    event.preventDefault();
    const locale =  event.srcElement.dataset.locale;

    fetch(`/locales/${locale}`, {
      method: 'GET'
    })
    .then(() => {
      window.location.reload();
    });
  }
}
